'use client';

import type { SendDataPayload } from '@/lib/services/notifications/workflow-hooks';
import {
  SendStep,
  type SendStepConfig,
  type SendStepInitialData,
  type SendStepResults
} from '../../_shared/send-step';

const NOTIFICATIONS_CONFIG: SendStepConfig = {
  correspondenceType: 'notification',
  loadingMessage: 'Preparing correspondence...',
  draftErrorMessage: 'Failed to prepare notifications. Please try again.',
  sendAllButtonLabel: 'Send All Correspondence',
  resultsItemLabel: 'notifications',
  nothingToSendMessage: 'No correspondences to send. All are pending research',
  supportsPostOnly: false
};

interface SendNotificationsStepProps {
  initialData?: SendStepInitialData;
  /** Required — see `SendStepProps.onSend` (VALE-546). */
  onSend: (data: SendDataPayload) => void | Promise<unknown>;
  onRefreshCorrespondences?: () => Promise<void>;
  isSending?: boolean;
  sendResults?: SendStepResults;
  matterId: number;
}

export function SendNotificationsStep(props: SendNotificationsStepProps) {
  return <SendStep<SendDataPayload> config={NOTIFICATIONS_CONFIG} {...props} />;
}
